export default "__VITE_ASSET__xDlgwb$f__"